import React, { useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { loadCSS } from 'fg-loadcss';

import { fetchEventPayments } from 'redux/actions/payment';
import {
  getInfoFromState,
  getUserEventFromState,
} from 'redux/selectors/customer';
import { getEventPaymentsFromState } from 'redux/selectors/payment';
import { Payments } from './Payments';

export const UserPayments = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const canceledPaymentId =
    searchParams.get('paymentError') === 'cancel'
      ? searchParams.get('paymentId')
      : null;

  useEffect(() => {
    const node = loadCSS(
      'https://use.fontawesome.com/releases/v5.12.0/css/all.css',
      document.querySelector('#font-awesome-css')
    );

    return () => {
      node.parentNode.removeChild(node);
    };
  }, []);

  useEffect(() => {
    dispatch(fetchEventPayments());
  }, [dispatch]);

  const { info } = useSelector((state) => getInfoFromState(state.customer));
  const { event } = useSelector((state) =>
    getUserEventFromState(state.customer)
  );
  const { additionalServices, eventPayments, paymentMethods } = useSelector(
    (state) => getEventPaymentsFromState(state.payment)
  );

  return (
    <Fragment>
      {info && event && eventPayments && (
        <Payments
          eventPayments={eventPayments}
          paymentMethods={paymentMethods}
          canceledPaymentId={canceledPaymentId}
        />
      )}

      {info && event && additionalServices && (
        <Payments
          additional={true}
          eventPayments={additionalServices}
          paymentMethods={paymentMethods}
          canceledPaymentId={canceledPaymentId}
        />
      )}
    </Fragment>
  );
};

export default UserPayments;
